import "antd/dist/antd.css"; // ✅ This must be before your own CSS files
import React from "react";
import { createRoot } from "react-dom/client";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import "./index.css";
import "./globalstyles/collapse.scss";
import "./globalstyles/antdtable.css";
import keycloak from "./keycloak";
import { Provider } from "react-redux";
import store from "./store/index"; // ← your Redux store
import App from "./App";
import { ENV } from "./config";
import { initRUM } from "./observability/faro";
import FaroErrorBoundary from "./observability/FaroErrorBoundary";


// Initialize RUM before render so early errors/web-vitals are captured. No-op
// when REACT_APP_FARO_URL is empty (local dev).
initRUM({
  appName: ENV.REACT_APP_FARO_APP_NAME || "inventory",
  environment: ENV.REACT_APP_ENVIRONMENT,
  collectorUrl: ENV.REACT_APP_FARO_URL,
  // Attach W3C traceparent to these backends so browser spans link to server traces.
  apiAllowedUrls: [ENV.REACT_APP_REST_API, ENV.REACT_APP_CENTRAL_AUTH],
  version: process.env.REACT_APP_VERSION || "1.0.0",
  sessionSampleRate: Number(ENV.REACT_APP_FARO_SAMPLE_RATE ?? 1),
  appKey: ENV.REACT_APP_FARO_APP_KEY,
});

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  // ErrorBoundary OUTSIDE the providers so it also catches Keycloak/init errors.
  <FaroErrorBoundary>
    <Provider store={store}>
      <ReactKeycloakProvider
        authClient={keycloak}
        initOptions={{
          onLoad: "login-required",
          checkLoginIframe: false, // disable if not using iframe login detection
        }}
      >
        <App />
      </ReactKeycloakProvider>
    </Provider>
  </FaroErrorBoundary>
);
